import React from "react";

const FAQComponent = () => {
  return (
    <>
      <section className="Faq">
        <div className="container">
          <div className="row">
            <div className="col-md-12  m-auto">
              <h2 className="title">Frequently asked questions</h2>
              <div className="FrequentlyBorder">
                <div className="row">
                  <div className="col-12">
                    <div className="faqContent">
                      <div className="faq faqbrdTop">
                        <a href="#!;" className="expand-btn open">
                          What is the eligibility criteria for Aspire program?
                        </a>
                        <div
                          className="hidden-content"
                          style={{ display: "block" }}
                        >
                          The applicants below 25 years of age and who have
                          completed graduation or Engineering in any discipline
                          this year with 60% in Class 10th and graduation can
                          apply. Post-Graduate or MBA freshers may also apply.
                          Total experience of the applicant should not exceed 6
                          months.
                        </div>
                      </div>
                      <div className="faq">
                        <a href="#!;" className="expand-btn">
                          I have completed the online aptitude test, when can I
                          expect the test result?
                        </a>
                        <div className="hidden-content">
                          <p>
                            If you are shortlisted, you will be informed about
                            further process through email in 3 days.
                          </p>
                        </div>
                      </div>
                      <div className="faq">
                        <a href="#!;" className="expand-btn">
                          After applying for the Aspire Program, when will I get
                          to know about my candidature?
                        </a>
                        <div className="hidden-content">
                          <p>
                            All shortlisted candidates will be informed through
                            email about the further process. You can also check
                            the status of your application in the iUniverse app.
                          </p>
                        </div>
                      </div>
                      <div className="faq">
                        <a href="#!;" className="expand-btn">
                          Can I get the score of the Aptitude Test?{" "}
                        </a>
                        <div className="hidden-content">
                          <p>No, test scores are not disclosed.</p>
                        </div>
                      </div>
                      <div className="faq">
                        <a href="#!;" className="expand-btn">
                          Does this role involve Sales?{" "}
                        </a>
                        <div className="hidden-content">
                          <p>
                            Yes. We at ICICI Bank believe in sales orientation,
                            irrespective of the roles we hold. It is a key
                            driver to deliver right product to a right customer.
                            In this role, the responsibilities largely revolve
                            around building existing relationships and
                            onboarding new customers to the bank by providing
                            360-degree banking solutions depending on the
                            customer's requirements. The role also entails
                            collaboration with various teams and stakeholders to
                            work towards the right solutions and market
                            strategy.{" "}
                            {/* <a href="mailto:po.programme@icicibank.com">
                              po.programme@icicibank.com
                            </a>{" "} */}
                          </p>
                        </div>
                      </div>
                      <div className="faq">
                        <a href="#!;" className="expand-btn">
                          What is the dress code for the personal interview
                          process?{" "}
                        </a>
                        <div className="hidden-content">
                          <p>
                            The dress code for the personal interview process is
                            business formals.
                          </p>
                        </div>
                      </div>
                      <div className="moretext" id="hidetxt5">
                        <div className="faq">
                          <a href="#!;" className="expand-btn">
                            How much time will it take to complete the personal
                            interview process?
                          </a>
                          <div className="hidden-content">
                            <p>
                              Personal interview will be a day-long process.{" "}
                            </p>
                          </div>
                        </div>
                        <div className="faq">
                          <a href="#!;" className="expand-btn">
                            I have registered with the wrong
                            salutation/gender/email ID. How can I update?
                          </a>
                          <div className="hidden-content">
                            <p>
                              Please drop an email from your registered email ID
                              along with your ID proof to
                              icicicareers@icicibank.com. The changes will get
                              updated.{" "}
                            </p>
                          </div>
                        </div>
                        <div className="faq">
                          <a href="#!;" className="expand-btn">
                            What is the time duration of online aptitude test?
                          </a>
                          <div className="hidden-content">
                            <p>The test duration is of 85 minutes. </p>
                          </div>
                        </div>
                        <div className="faq">
                          <a href="#!;" className="expand-btn">
                            Does the online aptitude test have negative scoring?
                          </a>
                          <div className="hidden-content">
                            <p>
                              No, there is no negative scoring in the test.{" "}
                            </p>
                          </div>
                        </div>
                        <div className="faq">
                          <a href="#!;" className="expand-btn">
                            What is the role being offered?
                          </a>
                          <div className="hidden-content">
                            <p>
                              The Aspire Programme will prepare selected
                              applicants for Relationship Manager (RM) job,
                              which is a sales role. This role will involve
                              client interactions and will require travel within
                              and around the assigned location/city.{" "}
                            </p>
                          </div>
                        </div>
                        <div className="faq">
                          <a href="#!;" className="expand-btn">
                            What is the syllabus of the online aptitude test?
                          </a>
                          <div className="hidden-content">
                            <p>
                              The test comprises of five sections (Verbal,
                              Quantitative, Logical ability, Video based
                              questions, General Awareness). Further details of
                              the test shall be communicated over e-mail.{" "}
                            </p>
                          </div>
                        </div>
                        {/* <div className="faq">
                          <a href="#!;" className="expand-btn">
                            How much stipend will I get?
                          </a>
                          <div className="hidden-content">
                            <p>
                              {" "}
                              ₹5,000 per month during 4 months classNameroom
                              training at Manipal, ₹22,000 to ₹24,000 per month
                              during 2 months internship, depending on the
                              location and ₹28,000 to ₹32,000 per month during 6
                              months OJT, depending on the location. A total
                              stipend of ₹2.32 lakh to ₹2.60 lakh, depending on
                              the location.
                            </p>
                          </div>
                        </div> */}
                        {/* <div className="faq">
                          <a href="#!;" className="expand-btn">
                            What will be my salary (CTC) after on-the-job
                            training?
                          </a>
                          <div className="hidden-content">
                            <p>
                              Starting salary (CTC) of ₹5 lakh to ₹5.50 lakh on
                              successful completion of the programme and joining
                              the Bank.{" "}
                            </p>
                          </div>
                        </div>
                        <div className="faq">
                          <a href="#!;" className="expand-btn">
                            What is the total course fee?
                          </a>
                          <div className="hidden-content">
                            <p>
                              The total course fee amount is ₹2,00,000 +
                              Applicable GST(18%) + 25000*(TAB cost at
                              actuals*)+ Applicable GST(18%){" "}
                            </p>
                          </div>
                        </div>
                        <div className="faq">
                          <a href="#!;" className="expand-btn">
                            If I choose self funding for the course, in whose
                            name Demand Draft (DD) should be taken?
                          </a>
                          <div className="hidden-content">
                            <p>
                              Demand Draft should be favouring "Manipal Global
                              Education Services Private Limited" payable in
                              Bengaluru.{" "}
                            </p>
                          </div>
                        </div>
                        <div className="faq">
                          <a href="#!;" className="expand-btn">
                            I will be reaching Bengaluru before the joining
                            dates. Can I get accommodation in the IMA?
                          </a>
                          <div className="hidden-content">
                            <p>
                              {" "}
                              The accommodation at the IMA will be provided
                              after the completion of the joining formalities
                              only.
                            </p>
                          </div>
                        </div>
                        <div className="faq">
                          <a href="#!;" className="expand-btn">
                            Can my parents/guardians be provided with the
                            accommodation at the IMA?
                          </a>
                          <div className="hidden-content">
                            <p>
                              No, accommodation will be provided only to the
                              candidates who complete the joining formalities at
                              ICICI Manipal Academy.{" "}
                            </p>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p align="center" className="mt-5">
                <a href="#!" className="btn readmore seeAll" rel="hidetxt5">
                  See all
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FAQComponent;
